import Logo from "../../components/svgs/logo";
import CraneImage from '../../assets/images/crane.jpg';
import BtBackground from '../bt-background/bt-background';
import { DOMAttributes, useEffect, useState }  from 'react';
import appState from '../../state/AppStateContainer';
import { ServiceAuth } from '../../services/service-auth';
import { AxiosError } from 'axios';
import BtColumn from "../bt-column/bt-column";
import BtGrid from "../bt-grid/bt-grid";
import BtRow from "../bt-row/bt-row";
import BtCenter from "../bt-center/bt-center";
import { useTranslation, Trans } from "react-i18next";

type CustomElement<T> = Partial<T & DOMAttributes<T> & { children: any }>;
declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['bt-center']: CustomElement<any>;
    }
  }
}

export default function PageSso() {
  const [t] = useTranslation('login', { keyPrefix: 'sso' } );
  const [error, setError] = useState("");
  const [logoutLink, setLogoutLink] = useState("");

  useEffect(() => {
    (async () => {
      const code = new URL(window.location.href).searchParams.get('code');
      if (code) {
        try {
          const data: any = await ServiceAuth.finishMicrosoftSignIn(code);
          if (data && !data.error) {
            await appState.setToken(data, true);
            const urlToRedirect = appState.loadString('urlToRedirect');
            localStorage.removeItem('urlToRedirect');
            window.location.href = urlToRedirect ?? "/";
            return;
          } else if (data && data.error) {
            setError(data.error);
            setLogoutLink(ServiceAuth.getMicrosoftLogoutLink(data.loginHint));
          } else {
            setError("Unknown error");
            setLogoutLink(ServiceAuth.getMicrosoftLogoutLink(null));
          }
        } catch (e) {
          const err = e as AxiosError;
          const data: any = err.response?.data;
          console.log(data)
          if (data?.error) {
            setError(data.error);
            setLogoutLink(ServiceAuth.getMicrosoftLogoutLink(data.loginHint));
          } else {
            setError("Unknown error");
            setLogoutLink(ServiceAuth.getMicrosoftLogoutLink(data.loginHint));
          }
        }
      } else {
        setError("No code");
      }

      appState.setState({loader: false});
    })();
  }, []);

  function renderSsoError(error: string) {
    if (error.startsWith("No organization")) {
      return <Trans t={t} i18nKey="errorMessage.noOrganization" values={{logoutLink}} components={{a: <a/>}} />;
    } else if (error.startsWith("No application role")) {
      return <Trans t={t} i18nKey="errorMessage.noApplicationRole" values={{logoutLink}} components={{a: <a/>}} />;
    } else if (error.startsWith("No code")) {
      return <Trans t={t} i18nKey="errorMessage.noCode" components={{a: <a/>}} />;
    } else if (error.startsWith("invalid_grant: 54005")) {
      return <Trans t={t} i18nKey="errorMessage.usedCode" components={{a: <a/>}} />;
    } else if (error.startsWith("invalid_grant: 70008")) {
      return <Trans t={t} i18nKey="errorMessage.expiredCode" components={{a: <a/>}} />;
    } else if (error.startsWith("invalid_grant: 9002313")) {
      return <Trans t={t} i18nKey="errorMessage.invalidCode" components={{a: <a/>}} />;
    } else {
      return <Trans t={t} i18nKey="errorMessage.unknown" values={{ logoutLink, error }} components={{ a: <a/> }} />;
    }
  }

  return <div className="page-login">
    <BtGrid>
        <BtRow>
            <BtColumn className="bt-w50 first-column bg-white">
                <BtCenter>
                  <div className="app-login bt-w60">
                    <Logo size="350px" type="logoWithTitle" />
                    <h2>{t('pageTitle', 'Inloggningen misslyckades')}</h2>
                    {renderSsoError(error)}
                  </div>
                </BtCenter>
            </BtColumn>
            <BtColumn className="second-column">
                <BtBackground className="bg-login bt-background-position-left" src={CraneImage} />
            </BtColumn>
        </BtRow>
    </BtGrid>
  </div>;
}
